import { Action } from 'redux';
import { ContributiState } from './models';
import { ContributiActions } from './actionTypes';

const initialState: ContributiState = { 
    inScadenza: []
};

export default (
    state: ContributiState = initialState, 
    incomingAction: Action
): ContributiState => {
    
    const action = incomingAction as ContributiActions;
    switch (action.type) {
        case 'core/MODIFICA_ANAGRAFICA':
            return initialState;
        case 'contributi/REQUEST_CONTRIBUTI_SCADENZE':
            return {
                ...state,
                inScadenza: action.value
            };
        case 'contributi/RESET_CONTRIBUTI':
            return {
                ...state,
                inScadenza: []
            };

        default: return state;
    }
  
    
};